/* k5 quick-add + PDP polish script (moved out of snippets/k5-quick-add.liquid, Oct 2026, so it is cached).
   Loaded with defer from that snippet; shop.money_format and the cart currency arrive via window.K5CFG. */
(function () {
  if (window.__k5QuickAdd) return; window.__k5QuickAdd = true;
  var ICON = '<span class="k5-qa-icon" aria-hidden="true"><svg role="presentation" stroke-width="1.2" focusable="false" width="15" height="15" viewBox="0 0 22 22"><path d="M11 7H3.577A2 2 0 0 0 1.64 9.497l2.051 8A2 2 0 0 0 5.63 19H16.37a2 2 0 0 0 1.937-1.503l2.052-8A2 2 0 0 0 18.422 7H11Zm0 0V1" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';

  // Rename Add to bag -> Add to cart (CSB wording)
  function renameATB() {
    document.querySelectorAll('.product-form__submit').forEach(function (b) {
      var span = b.querySelector('span') || b;
      if (/add to bag/i.test(span.textContent)) span.textContent = span.textContent.replace(/add to bag/i, 'Add to cart');
    });
  }
  // Zoom + button on the active product image -> triggers theme lightbox
  // ===== Gallery lightbox (multi-image, prev/next, counter) =====
  var k5lb = null, k5imgs = [], k5idx = 0, k5cache = {}, k5token = 0;
  function collectImages() {
    var out = [], seen = {};
    document.querySelectorAll('.product__media-wrapper .product__media-item img, .product__media-wrapper img').forEach(function (im) {
      var src = im.currentSrc || im.src; if (!src) return;
      var base = src.split('?')[0];
      if (seen[base]) return; seen[base] = 1;
      out.push(src.replace(/([?&])width=\d+/, '$1width=1600'));
    });
    return out;
  }
  function preload(idx) {
    var src = k5imgs[idx]; if (!src || k5cache[src]) return;
    var im = new Image(); im.src = src; k5cache[src] = im;
  }
  function preloadNeighbors() {
    if (k5imgs.length < 2) return;
    preload((k5idx + 1) % k5imgs.length);
    preload((k5idx - 1 + k5imgs.length) % k5imgs.length);
  }
  function renderLB() {
    var img = k5lb.querySelector('.k5-lb-img');
    var src = k5imgs[k5idx] || '';
    k5lb.querySelector('.k5-lb-count').textContent = (k5idx + 1) + ' / ' + k5imgs.length;
    k5lb.querySelector('.k5-lb-nav').style.display = k5imgs.length > 1 ? 'flex' : 'none';
    if (!src || img.src === src) { preloadNeighbors(); return; }
    var my = ++k5token;
    var cached = k5cache[src];
    var swap = function () { if (my !== k5token) return; img.src = src; img.classList.remove('k5-lb-loading'); preloadNeighbors(); };
    if (cached && cached.complete) { swap(); return; }         // already in cache -> instant
    img.classList.add('k5-lb-loading');                        // dim current while the new one arrives
    var pre = cached || (k5cache[src] = new Image()); pre.src = src;
    if (pre.decode) { pre.decode().then(swap).catch(swap); } else { pre.onload = swap; pre.onerror = swap; }
  }
  function openLightbox(startIdx) {
    k5imgs = collectImages(); if (!k5imgs.length) return;
    k5idx = Math.max(0, Math.min(startIdx || 0, k5imgs.length - 1));
    k5imgs.forEach(function (_, i) { preload(i); });           // warm the whole gallery on open
    if (!k5lb) {
      k5lb = document.createElement('div'); k5lb.className = 'k5-lb';
      k5lb.innerHTML = '<button class="k5-lb-close" aria-label="Close">&times;</button>'
        + '<img class="k5-lb-img" alt="">'
        + '<div class="k5-lb-nav"><button class="k5-lb-prev" aria-label="Previous">&#8249;</button>'
        + '<span class="k5-lb-count"></span>'
        + '<button class="k5-lb-next" aria-label="Next">&#8250;</button></div>';
      document.body.appendChild(k5lb);
      k5lb.addEventListener('click', function (e) { if (e.target === k5lb || e.target.classList.contains('k5-lb-close')) closeLightbox(); });
      k5lb.querySelector('.k5-lb-prev').addEventListener('click', function (e) { e.stopPropagation(); k5idx = (k5idx - 1 + k5imgs.length) % k5imgs.length; renderLB(); });
      k5lb.querySelector('.k5-lb-next').addEventListener('click', function (e) { e.stopPropagation(); k5idx = (k5idx + 1) % k5imgs.length; renderLB(); });
      document.addEventListener('keydown', function (e) {
        if (!k5lb.classList.contains('k5-lb-open')) return;
        if (e.key === 'Escape') closeLightbox();
        if (e.key === 'ArrowLeft') { k5idx = (k5idx - 1 + k5imgs.length) % k5imgs.length; renderLB(); }
        if (e.key === 'ArrowRight') { k5idx = (k5idx + 1) % k5imgs.length; renderLB(); }
      });
    }
    renderLB();
    k5lb.classList.add('k5-lb-open'); document.documentElement.style.overflow = 'hidden';
  }
  function closeLightbox() { if (k5lb) { k5lb.classList.remove('k5-lb-open'); document.documentElement.style.overflow = ''; } }
  // clean CSB-style "+" icon
  var ZOOM = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M12 6.5v11M6.5 12h11"/></svg>';
  function placeZoom() {
    var wrap = document.querySelector('.product__media-wrapper');
    if (!wrap) return;
    var items = wrap.querySelectorAll('.product__media-item');
    (items.length ? items : [wrap]).forEach(function (item, i) {
      if (item.querySelector(':scope > .k5-zoom-btn')) return;
      if (getComputedStyle(item).position === 'static') item.style.position = 'relative';
      var btn = document.createElement('button');
      btn.type = 'button'; btn.className = 'k5-zoom-btn'; btn.setAttribute('aria-label','Zoom image'); btn.innerHTML = ZOOM;
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var imgSrc = (item.querySelector('img') || {}).currentSrc || (item.querySelector('img') || {}).src || '';
        var base = imgSrc.split('?')[0];
        var all = collectImages();
        var idx = all.findIndex(function (u) { return u.split('?')[0] === base; });
        openLightbox(idx < 0 ? 0 : idx);
      });
      item.appendChild(btn);
    });
  }
  // ===== Reviews text -> "N Reviews" (strip parens) =====
  function formatReviews() {
    // NEVER rewrite Judge.me's own node (it reverts and fighting it freezes the page).
    // Hide theirs via CSS and maintain our own sibling span instead.
    document.querySelectorAll('.jdgm-prev-badge__text').forEach(function (el) {
      var n = (el.textContent.match(/\d[\d,]*/) || [])[0];
      if (!n) return;
      var want = n + ' Review' + (n === '1' ? '' : 's');
      var sib = el.parentElement.querySelector('.k5-rev');
      if (!sib) { sib = document.createElement('span'); sib.className = 'k5-rev'; el.insertAdjacentElement('afterend', sib); }
      if (sib.textContent !== want) sib.textContent = want;
    });
  }
  // Judge.me renders async: apply a few delayed one-shot passes only.
  // NO MutationObserver here - observing the badge fights Judge.me's own
  // rendering in a synchronous loop and freezes the page.
  setTimeout(formatReviews, 1500);
  setTimeout(formatReviews, 4000);
  // ===== Save X% pill next to price (replaces orange "20% OFF") =====
  // pct is computed PER price block from its own sale + compare-at numbers, so
  // full-price items (e.g. Shop The Look cards) never inherit the main product's discount.
  function k5ParsePrice(el) {
    if (!el) return null;
    var t = (el.textContent || '').replace(/[^0-9.,]/g, '');
    if (!t) return null;
    t = t.replace(/,/g, '.');
    var parts = t.split('.');
    if (parts.length > 2) t = parts.slice(0, -1).join('') + '.' + parts[parts.length - 1];
    var n = parseFloat(t);
    return isNaN(n) ? null : n;
  }
  function savePill() {
    ['.mobile-content', '.product__info-container'].forEach(function (sc) {
      var scope = document.querySelector(sc); if (!scope) return;
      scope.querySelectorAll('.price').forEach(function (priceEl) {
        var container = priceEl.querySelector('.price__container');
        if (!container || priceEl.querySelector('.k5-save')) return;
        var sale = k5ParsePrice(priceEl.querySelector('.price__sale .price-item--sale, .price-item--sale'));
        var reg = k5ParsePrice(priceEl.querySelector('.price__sale s.price-item--regular, s.price-item--regular'));
        if (!sale || !reg || reg <= sale) return;
        // Oct 21 2026: show the amount saved ("Save $10"), computed from the two prices on the page,
        // written in the same currency format as the sale price the shopper sees.
        var diff = Math.round((reg - sale) * 100) / 100;
        if (diff < 1) return;
        var saleTxt = (priceEl.querySelector('.price__sale .price-item--sale, .price-item--sale').textContent || '').trim();
        var numRe = /\d[\d.,\s]*\d|\d/;
        var commaDec = /\d,\d{2}(?!\d)/.test(saleTxt);
        var amt = (diff % 1 === 0) ? String(diff) : diff.toFixed(2);
        if (commaDec) amt = amt.replace('.', ',');
        var label = numRe.test(saleTxt) ? saleTxt.replace(numRe, amt) : amt;
        var pill = document.createElement('span');
        pill.className = 'k5-save'; pill.textContent = 'Save ' + label;
        container.appendChild(pill);
      });
    });
  }
    function setupSort() {
    document.querySelectorAll('.mobile-facets__sort').forEach(function (sort) {
      var sel = sort.querySelector('select'); if (!sel) return;
      var val = sort.querySelector('.k5-sortval');
      if (!val) { val = document.createElement('span'); val.className = 'k5-sortval'; sort.insertBefore(val, sort.firstChild); }
      var upd = function () { var o = sel.options[sel.selectedIndex]; val.textContent = 'Sort by: ' + (o ? o.text.trim() : ''); };
      if (!sel.__k5sort) { sel.addEventListener('change', upd); sel.__k5sort = true; }
      upd();
    });
  }
  function placePills() {
    renameATB(); placeZoom(); formatReviews(); savePill(); setupSort();
    document.querySelectorAll('.quick-add-button-container').forEach(function (p) {
      if (!p.__k5icon) { p.insertAdjacentHTML('afterbegin', ICON); p.__k5icon = true; }
      if (!p.querySelector('.k5-qa-label')) { p.insertAdjacentHTML('beforeend', '<span class="k5-qa-label">+ Quick add</span>'); }
      if (p.__k5placed) return;
      var card = p.closest('.card, .card-wrapper, .shop-the-look__item, .mic-grid > li, .related-products .swiper-slide');
      if (!card) return;
      var media = card.querySelector('.card__media');
      if (!media) { p.__k5placed = true; return; }
      var anchor = media.querySelector(':scope > .k5-qa-anchor');
      if (!anchor) { anchor = document.createElement('div'); anchor.className = 'k5-qa-anchor'; media.appendChild(anchor); }
      if (p.parentElement !== anchor) anchor.appendChild(p);
      p.__k5placed = true;
    });
  }
  if (document.readyState !== 'loading') placePills(); else document.addEventListener('DOMContentLoaded', placePills);
  window.addEventListener('load', function () { placePills(); setTimeout(placePills, 1200); setTimeout(placePills, 3500); setTimeout(placePills, 7000); });
  var pending = false;
  new MutationObserver(function (muts) {
    if (pending) return;
    if (!muts.some(function (m) { return [].some.call(m.addedNodes, function (n) { return n.nodeType === 1 && n.querySelector && n.querySelector('.quick-add-button-container'); }); })) return;
    pending = true; requestAnimationFrame(function () { pending = false; placePills(); });
  }).observe(document.body, { childList: true, subtree: true });

  // ---- modal ----
  var backdrop, modal, cur = { sizeIdx: 0, product: null, vid: null };
  // Prices from /products/<handle>.js are already in the shopper's active currency (presentment cents).
  // Format them the way the product cards do: Shopify renders shop.money_format for the active currency on
  // each request (US "$60", Spain "€53,95"). If that format is missing or the currency doesn't match,
  // fall back to Intl with the active currency, then to US dollars.
  var K5CFG = window.K5CFG || {}, K5_FMT = K5CFG.fmt, K5_FMT_CUR = K5CFG.cur || 'USD';
  function k5Delim(cents, dp, th, dec) {
    var x = (Math.round(cents) / 100).toFixed(dp).split('.');
    x[0] = x[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
    return x[0] + (x[1] ? dec + x[1] : '');
  }
  function money(cents) {
    cents = Math.round(+cents || 0);
    var sh = window.Shopify || {}, active = (sh.currency && sh.currency.active) || K5_FMT_CUR || 'USD';
    if (K5_FMT && active === K5_FMT_CUR) {
      var m = K5_FMT.match(/\{\{\s*(\w+)\s*\}\}/), key = m ? m[1] : 'amount';
      var v = ({
        amount: [2, ',', '.'], amount_no_decimals: [0, ',', '.'],
        amount_with_comma_separator: [2, '.', ','], amount_no_decimals_with_comma_separator: [0, '.', ','],
        amount_with_space_separator: [2, ' ', ','], amount_no_decimals_with_space_separator: [0, ' ', ','],
        amount_with_apostrophe_separator: [2, "'", '.'], amount_with_period_and_space_separator: [2, ' ', '.']
      })[key] || [2, ',', '.'];
      return K5_FMT.replace(/\{\{\s*\w+\s*\}\}/, k5Delim(cents, v[0], v[1], v[2]));
    }
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: active }).format(cents / 100); }
    catch (e) { return '$' + k5Delim(cents, cents % 100 ? 2 : 0, ',', '.'); }
  }
  function buildModal() {
    backdrop = document.createElement('div'); backdrop.className = 'k5-qm-backdrop'; backdrop.hidden = true;
    modal = document.createElement('div'); modal.className = 'k5-qm'; modal.setAttribute('role', 'dialog'); modal.setAttribute('aria-modal', 'true'); modal.hidden = true;
    modal.innerHTML = '<button class="k5-qm-close" aria-label="Close">&times;</button>'
      + '<div class="k5-qm-head"><img class="k5-qm-img" alt=""><div class="k5-qm-meta"><div class="k5-qm-title"></div><div class="k5-qm-price"></div></div></div>'
      + '<div class="k5-qm-sizelabel">Size: <span class="k5-qm-selsize"></span></div>'
      + '<div class="k5-qm-sizes"></div>'
      + '<button class="k5-qm-add">Add to cart</button>';
    document.body.appendChild(backdrop); document.body.appendChild(modal);
    backdrop.addEventListener('click', closeModal);
    modal.querySelector('.k5-qm-close').addEventListener('click', closeModal);
    modal.querySelector('.k5-qm-add').addEventListener('click', function () {
      if (cur.vid) addVariant(cur.vid).then(closeModal);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });
  }
  function openModal(p) {
    if (!modal) buildModal();
    cur.product = p;
    var opts = (p.options || []).map(function (o) { return (typeof o === 'string' ? o : (o.name || '')).toLowerCase(); });
    cur.sizeIdx = opts.indexOf('size');
    modal.querySelector('.k5-qm-img').src = (p.featured_image || (p.media && p.media[0] && p.media[0].preview_image && p.media[0].preview_image.src) || '');
    modal.querySelector('.k5-qm-title').textContent = (p.title || '').split('|')[0].trim();
    var priceEl = modal.querySelector('.k5-qm-price');
    priceEl.innerHTML = money(p.price) + (p.compare_at_price && p.compare_at_price > p.price ? ' <span class="k5-qm-was">' + money(p.compare_at_price) + '</span>' : '');
    var wrap = modal.querySelector('.k5-qm-sizes'); wrap.innerHTML = '';
    cur.vid = null; modal.querySelector('.k5-qm-selsize').textContent = '';
    var seen = {};
    p.variants.forEach(function (v) {
      var sv = cur.sizeIdx >= 0 ? v.options[cur.sizeIdx] : v.title;
      if (seen[sv] !== undefined) return; seen[sv] = 1;
      var match = null;
      for (var i = 0; i < p.variants.length; i++) { var xv = cur.sizeIdx >= 0 ? p.variants[i].options[cur.sizeIdx] : p.variants[i].title; if (xv === sv && p.variants[i].available) { match = p.variants[i]; break; } }
      var b = document.createElement('button'); b.type = 'button'; b.className = 'k5-qm-size'; b.textContent = sv;
      if (!match) { b.setAttribute('disabled', 'disabled'); }
      else { b.setAttribute('data-vid', match.id); b.addEventListener('click', function () { selectSize(b, sv, match.id); }); }
      wrap.appendChild(b);
    });
    // preselect first available
    var first = wrap.querySelector('.k5-qm-size:not([disabled])');
    if (first) selectSize(first, first.textContent, first.getAttribute('data-vid'));
    show();
  }
  function selectSize(btn, label, vid) {
    modal.querySelectorAll('.k5-qm-size').forEach(function (x) { x.classList.remove('k5-sel'); });
    btn.classList.add('k5-sel'); cur.vid = vid; modal.querySelector('.k5-qm-selsize').textContent = label;
  }
  function show() { backdrop.hidden = false; modal.hidden = false; requestAnimationFrame(function () { backdrop.classList.add('k5-open'); modal.classList.add('k5-open'); }); document.documentElement.style.overflow = 'hidden'; }
  function closeModal() { if (!modal) return; backdrop.classList.remove('k5-open'); modal.classList.remove('k5-open'); document.documentElement.style.overflow = ''; setTimeout(function () { backdrop.hidden = true; modal.hidden = true; }, 280); }

  function openCart() {
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:build'));
    window.dispatchEvent(new Event('resize'));
    var t = document.querySelector('#cart-icon-bubble, [href="/cart"], .cart-icon');
    if (t) { try { t.click(); } catch (e) {} }
  }
  function addVariant(id) { return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }) }).then(function () { openCart(); }); }

  document.addEventListener('click', function (e) {
    var swatchLink = e.target.closest ? e.target.closest('.card-wrapper .swatch-element a.grid-color') : null;
    if (swatchLink) {
      var group = swatchLink.closest('.swatch');
      if (group) {
        group.querySelectorAll('.swatch-element').forEach(function (x) { x.classList.remove('active-color'); });
        var el = swatchLink.closest('.swatch-element'); if (el) el.classList.add('active-color');
      }
    }
    var pill = e.target.closest ? e.target.closest('.quick-add-button-container') : null;
    if (!pill) return;
    e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    var handle = pill.getAttribute('data-product-handle');
    if (!handle) {
      var hostCard = pill.closest('.card, .card-wrapper, li, .swiper-slide');
      var link = hostCard && hostCard.querySelector('a[href*="/products/"]');
      var hm = link && (link.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/);
      if (hm) handle = hm[1];
    }
    if (!handle) return;
    fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
      var avail = (p.variants || []).filter(function (v) { return v.available; });
      if (avail.length <= 1) { if (avail[0]) addVariant(avail[0].id); else window.location.href = '/products/' + handle; return; }
      openModal(p);
    }).catch(function () { window.location.href = '/products/' + handle; });
  }, true);
})();
